import { ReactNode } from "react";
import { FLOATING_CHAT_BUTTON_BOTTOM_RAISED } from "../../../../features/messaging/messagingSlice";
import { useFloatingChatButtonBottom } from "../../../../features/messaging/useFloatingChatButtonBottom";
import { SelectionActionBarRoot } from "./styles";

type Props = {
  children: ReactNode;
};

export const SelectionActionBar = ({ children }: Props) => {
  useFloatingChatButtonBottom(FLOATING_CHAT_BUTTON_BOTTOM_RAISED);

  return (
    <SelectionActionBarRoot data-testid="selection-action-bar">
      {children}
    </SelectionActionBarRoot>
  );
};
